import Loadable from '../../components/loadable';

const ProspectKanbanList = Loadable({
  loader: () => import('../../pages/contacts/prospect_kanban_list'),
  type: 'block',
});

angular.module('gym').value('ProspectKanbanList', ProspectKanbanList);
